<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="HandoverProtocol"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
    <UcContractProtocolHeader
      :protocol="item"
      @close="evh_8564662037462133_close($event, {})"
      @reload="evh_8564662037462133_reload($event, {})"
      @deleted="evh_8564662037462133_deleted($event, {})"
    >
    </UcContractProtocolHeader>
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpForm
      :id="formId"
      :name="formName"
      @submit="evh_1040167445267876_submit($event, {})"
    >
      <FieldsetHandoverProtocol
        :item="item"
        :form="forms[formName]"
        @reload="evh_5534025912102772_reload($event, {})"
        @close="evh_5534025912102772_close($event, {})"
        @changed="evh_5534025912102772_changed($event, {})"
      >
      </FieldsetHandoverProtocol>
    </ItpForm>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      type="submit"
      :form="formId"
      variant="primary"
      icon="fa-save"
      :text="'Save'|gettext"
      :spinning="actions.save.isRunning"
      :disabled="!forms[formName] || !forms[formName].submittable"
      v-if="loaded && item.protocol_status === 'draft'"
      @click.prevent.stop="evh_1548630417156826_clickPreventStop($event, {})"
    >
    </ItpButton>
    <ItpButton
      variant="default"
      :text="'Close'|gettext"
      :disabled="actions.save.isRunning"
      class="ml-3"
      @click.prevent.stop="evh_1419464017721962_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class HandoverProtocol extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  @Prop({
    type: String,
  })
  oid!: string;

  @Watch('oid')
  onOid(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("oid")
  }

  @Prop({
    type: String,
  })
  contractId!: string;

  @Watch('contractId')
  onContract_id(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("contractId")
  }

  @Prop({
    type: String,
  })
  revisionId!: string;

  @Watch('revisionId')
  onRevision_id(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("revisionId")
  }

  @Prop({
    type: String,
  })
  handoverType!: string;

  @Watch('handoverType')
  onHandover_type(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("handoverType")
  }

  @Prop({
    type: String,
    default: "lg",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  item!: any;

  async $$load_item() {
    return this.oid ?
      this.$fn.fetch('read_contract_protocol', {
        asResource: true,
        parameters: { id: this.oid }
      }) :
      this.$fn.fetch('get_contract_protocol_template', {
        asResource: true,
        parameters: {
          contract_id: this.contractId,
          revision_id: this.revisionId,
          handover_type: this.handoverType,
        }
      })
  }

  formName!: any;
  formId!: any;

  async $$load_formId() {
    return this.$fn.randomElementId()
  }

  labelAlign!: any;
  handoverTypes!: any;

  async $$load_handoverTypes() {
    return this.$fn.getEnumValuesFromSchema('HandoverType')
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  dataMembers = ['item', 'formName', 'formId', 'labelAlign', 'handoverTypes', 'ux', 'b_7315092382398562_modalBindings'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        item: null,
        formName: "handoverProtocol",
        formId: null,
        labelAlign: "left",
        handoverTypes: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "lg",
        }
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: [this.$fn.pgettext("Contract", "Handover protocol")
          ,
        this.$fn.pgettext("HandoverType", this.item.handover_type, "Sentence")
          ,
        ]
        ,
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_8510_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_8510, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_8564662037462133_closeModal_8514_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_8564662037462133_closeModal_8514, alias=undefined
    return {
      result: {
        ok: true,
      }
      ,
    }
  }

  async evh_8564662037462133_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8564662037462133_close.executeFromDOM(this, event, scope);
  }

  async evh_8564662037462133_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8564662037462133_reload.executeFromDOM(this, event, scope);
  }

  async act_8564662037462133_closeModal_8518_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_8564662037462133_closeModal_8518, alias=undefined
    return {
      result: {
        ok: true,
      }
      ,
    }
  }

  async evh_8564662037462133_deleted(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8564662037462133_deleted.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_script_8522_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_1040167445267876_script_8522, alias=undefined
    _.isEmpty($event.data) ? this.item : this.item.reset($event.data)
  }

  async act_1040167445267876_script_8522_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_1040167445267876_script_8522, alias=undefined
    return {
      value: () => this.act_1040167445267876_script_8522_getActionArgs_value($event),
    }
  }

  async evh_1040167445267876_success_8521_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_1040167445267876_success_8521, alias=undefined
    return !!$event.data
  }

  async act_1040167445267876_crud_8520_getActionArgs($event: actions.ActionEvent): Promise<actions.CRUDActionArgs> {
    // parameterResolver name=act_1040167445267876_crud_8520, alias=save
    return {
      objectType: "contract_protocol",
      op: "upsert",
      data: this.item,
    }
  }

  async evh_1040167445267876_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
  }

  async evh_5534025912102772_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5534025912102772_reload.executeFromDOM(this, event, scope);
  }

  async evh_5534025912102772_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5534025912102772_close.executeFromDOM(this, event, scope);
  }

  async act_5534025912102772_emit_8528_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_5534025912102772_emit_8528, alias=undefined
    return {
      event: "saved",
      value: $event.data,
    }
  }

  async evh_5534025912102772_changed(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5534025912102772_changed.executeFromDOM(this, event, scope);
  }

  async act_1548630417156826_script_8532_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_1548630417156826_script_8532, alias=undefined
    _.isEmpty($event.data) ? this.item : this.item.reset($event.data)
  }

  async act_1548630417156826_script_8532_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_1548630417156826_script_8532, alias=undefined
    return {
      value: () => this.act_1548630417156826_script_8532_getActionArgs_value($event),
    }
  }

  async evh_1548630417156826_success_8531_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_1548630417156826_success_8531, alias=undefined
    return !!$event.data
  }

  async act_1548630417156826_crud_8530_getActionArgs($event: actions.ActionEvent): Promise<actions.CRUDActionArgs> {
    // parameterResolver name=act_1548630417156826_crud_8530, alias=save
    return {
      objectType: "contract_protocol",
      op: "upsert",
      data: this.item,
    }
  }

  async evh_1548630417156826_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1548630417156826_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_1419464017721962_closeComponent_8534_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseComponentActionArgs> {
    // parameterResolver name=act_1419464017721962_closeComponent_8534, alias=undefined
    return {
      result: {
        ok: true,
      }
      ,
    }
  }

  async evh_1419464017721962_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_8510: actions.CloseModalAction;
    evh_7315092382398562_close_8509: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeModal_8512: actions.CloseModalAction;
    evh_2248226175642056_close_8511: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_8564662037462133_closeModal_8514: actions.CloseModalAction;
    evh_8564662037462133_close_8513: actions.EventHandlerImpl;
    evh_8564662037462133_close: actions.EventHandlerGroup;
    act_8564662037462133_reloadComponentData_8516: actions.ReloadComponentDataAction;
    evh_8564662037462133_reload_8515: actions.EventHandlerImpl;
    evh_8564662037462133_reload: actions.EventHandlerGroup;
    act_8564662037462133_closeModal_8518: actions.CloseModalAction;
    evh_8564662037462133_deleted_8517: actions.EventHandlerImpl;
    evh_8564662037462133_deleted: actions.EventHandlerGroup;
    act_1040167445267876_script_8522: actions.ScriptAction;
    evh_1040167445267876_success_8521: actions.EventHandlerImpl;
    act_1040167445267876_crud_8520: actions.CRUDAction;
    evh_1040167445267876_submit_8519: actions.EventHandlerImpl;
    evh_1040167445267876_submit: actions.EventHandlerGroup;
    act_5534025912102772_reloadComponentData_8524: actions.ReloadComponentDataAction;
    evh_5534025912102772_reload_8523: actions.EventHandlerImpl;
    evh_5534025912102772_reload: actions.EventHandlerGroup;
    act_5534025912102772_closeComponent_8526: actions.CloseComponentAction;
    evh_5534025912102772_close_8525: actions.EventHandlerImpl;
    evh_5534025912102772_close: actions.EventHandlerGroup;
    act_5534025912102772_emit_8528: actions.EmitAction;
    evh_5534025912102772_changed_8527: actions.EventHandlerImpl;
    evh_5534025912102772_changed: actions.EventHandlerGroup;
    act_1548630417156826_script_8532: actions.ScriptAction;
    evh_1548630417156826_success_8531: actions.EventHandlerImpl;
    act_1548630417156826_crud_8530: actions.CRUDAction;
    evh_1548630417156826_clickPreventStop_8529: actions.EventHandlerImpl;
    evh_1548630417156826_clickPreventStop: actions.EventHandlerGroup;
    act_1419464017721962_closeComponent_8534: actions.CloseComponentAction;
    evh_1419464017721962_clickPreventStop_8533: actions.EventHandlerImpl;
    evh_1419464017721962_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_8510 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_8510_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_8509 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_8510,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_8509],
      }
    );
    const act_2248226175642056_closeModal_8512 = new actions.CloseModalAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_8511 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeModal_8512,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_8511],
      }
    );
    const act_8564662037462133_closeModal_8514 = new actions.CloseModalAction(
      {
        actionArgs: this.act_8564662037462133_closeModal_8514_getActionArgs,
        events: [],
      }
    );
    const evh_8564662037462133_close_8513 = new actions.EventHandlerImpl(
      {
        action: act_8564662037462133_closeModal_8514,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_8564662037462133_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_8564662037462133_close_8513],
      }
    );
    const act_8564662037462133_reloadComponentData_8516 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_8564662037462133_reload_8515 = new actions.EventHandlerImpl(
      {
        action: act_8564662037462133_reloadComponentData_8516,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_8564662037462133_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_8564662037462133_reload_8515],
      }
    );
    const act_8564662037462133_closeModal_8518 = new actions.CloseModalAction(
      {
        actionArgs: this.act_8564662037462133_closeModal_8518_getActionArgs,
        events: [],
      }
    );
    const evh_8564662037462133_deleted_8517 = new actions.EventHandlerImpl(
      {
        action: act_8564662037462133_closeModal_8518,
        event: "deleted",
        displayName: "closeModal",
      }
    );
    const evh_8564662037462133_deleted = new actions.EventHandlerGroup(
      {
        handlers: [evh_8564662037462133_deleted_8517],
      }
    );
    const act_1040167445267876_script_8522 = new actions.ScriptAction(
      {
        actionArgs: this.act_1040167445267876_script_8522_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_success_8521 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_script_8522,
        event: "success",
        when: this.evh_1040167445267876_success_8521_getWhen,
        displayName: "script",
      }
    );
    const act_1040167445267876_crud_8520 = new actions.CRUDAction(
      {
        actionArgs: this.act_1040167445267876_crud_8520_getActionArgs,
        displayName: "save",
        events: [evh_1040167445267876_success_8521],
      }
    );
    const evh_1040167445267876_submit_8519 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_crud_8520,
        event: "submit",
        displayName: "save",
      }
    );
    const evh_1040167445267876_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_submit_8519],
      }
    );
    const act_5534025912102772_reloadComponentData_8524 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_5534025912102772_reload_8523 = new actions.EventHandlerImpl(
      {
        action: act_5534025912102772_reloadComponentData_8524,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_5534025912102772_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_5534025912102772_reload_8523],
      }
    );
    const act_5534025912102772_closeComponent_8526 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_5534025912102772_close_8525 = new actions.EventHandlerImpl(
      {
        action: act_5534025912102772_closeComponent_8526,
        event: "close",
        displayName: "closeComponent",
      }
    );
    const evh_5534025912102772_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_5534025912102772_close_8525],
      }
    );
    const act_5534025912102772_emit_8528 = new actions.EmitAction(
      {
        actionArgs: this.act_5534025912102772_emit_8528_getActionArgs,
        events: [],
      }
    );
    const evh_5534025912102772_changed_8527 = new actions.EventHandlerImpl(
      {
        action: act_5534025912102772_emit_8528,
        event: "changed",
        displayName: "emit",
      }
    );
    const evh_5534025912102772_changed = new actions.EventHandlerGroup(
      {
        handlers: [evh_5534025912102772_changed_8527],
      }
    );
    const act_1548630417156826_script_8532 = new actions.ScriptAction(
      {
        actionArgs: this.act_1548630417156826_script_8532_getActionArgs,
        events: [],
      }
    );
    const evh_1548630417156826_success_8531 = new actions.EventHandlerImpl(
      {
        action: act_1548630417156826_script_8532,
        event: "success",
        when: this.evh_1548630417156826_success_8531_getWhen,
        displayName: "script",
      }
    );
    const act_1548630417156826_crud_8530 = new actions.CRUDAction(
      {
        actionArgs: this.act_1548630417156826_crud_8530_getActionArgs,
        displayName: "save",
        events: [evh_1548630417156826_success_8531],
      }
    );
    const evh_1548630417156826_clickPreventStop_8529 = new actions.EventHandlerImpl(
      {
        action: act_1548630417156826_crud_8530,
        event: "click.prevent.stop",
        displayName: "save",
      }
    );
    const evh_1548630417156826_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1548630417156826_clickPreventStop_8529],
      }
    );
    const act_1419464017721962_closeComponent_8534 = new actions.CloseComponentAction(
      {
        actionArgs: this.act_1419464017721962_closeComponent_8534_getActionArgs,
        events: [],
      }
    );
    const evh_1419464017721962_clickPreventStop_8533 = new actions.EventHandlerImpl(
      {
        action: act_1419464017721962_closeComponent_8534,
        event: "click.prevent.stop",
        displayName: "closeComponent",
      }
    );
    const evh_1419464017721962_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1419464017721962_clickPreventStop_8533],
      }
    );
    return {
      act_7315092382398562_closeModal_8510,
      evh_7315092382398562_close_8509,
      evh_7315092382398562_close,
      act_2248226175642056_closeModal_8512,
      evh_2248226175642056_close_8511,
      evh_2248226175642056_close,
      act_8564662037462133_closeModal_8514,
      evh_8564662037462133_close_8513,
      evh_8564662037462133_close,
      act_8564662037462133_reloadComponentData_8516,
      evh_8564662037462133_reload_8515,
      evh_8564662037462133_reload,
      act_8564662037462133_closeModal_8518,
      evh_8564662037462133_deleted_8517,
      evh_8564662037462133_deleted,
      act_1040167445267876_script_8522,
      evh_1040167445267876_success_8521,
      act_1040167445267876_crud_8520,
      evh_1040167445267876_submit_8519,
      evh_1040167445267876_submit,
      act_5534025912102772_reloadComponentData_8524,
      evh_5534025912102772_reload_8523,
      evh_5534025912102772_reload,
      act_5534025912102772_closeComponent_8526,
      evh_5534025912102772_close_8525,
      evh_5534025912102772_close,
      act_5534025912102772_emit_8528,
      evh_5534025912102772_changed_8527,
      evh_5534025912102772_changed,
      act_1548630417156826_script_8532,
      evh_1548630417156826_success_8531,
      act_1548630417156826_crud_8530,
      evh_1548630417156826_clickPreventStop_8529,
      evh_1548630417156826_clickPreventStop,
      act_1419464017721962_closeComponent_8534,
      evh_1419464017721962_clickPreventStop_8533,
      evh_1419464017721962_clickPreventStop,
      save: act_1548630417156826_crud_8530,
    }
  }
}

Vue.component("HandoverProtocol", HandoverProtocol);

</script>